import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/cpjs_bg.png';
import _imports_1 from '@/assets/img/game.png';
import _imports_2 from '@/assets/img/game_bg.png';
import _imports_3 from '@/assets/img/btn.png';
const _withScopeId = n => (_pushScopeId("data-v-890d2258"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-890d2258><img src=\"" + _imports_0 + "\" alt=\"\" data-v-890d2258></div><div class=\"company_jj\" data-v-890d2258><div class=\"jieshao\" data-v-890d2258><h2 data-v-890d2258>产品<b data-v-890d2258>介绍</b></h2><p data-v-890d2258> 无敌泡泡龙游戏是一款热门的消除闯关游戏，游戏采用简约的画面设计，在游戏中玩家将体验到最独特的闯关消除玩法，超多的游戏关卡在这里等你来挑战，喜欢的不要错过了！ </p><img src=\"" + _imports_1 + "\" alt=\"\" data-v-890d2258></div></div><div class=\"bottom\" data-v-890d2258><img src=\"" + _imports_2 + "\" alt=\"\" data-v-890d2258><div class=\"info\" data-v-890d2258><p data-v-890d2258> 游戏特色： <br data-v-890d2258>精心设计的画面场景给你最好的视觉体验 <br data-v-890d2258>操作也很简单，上手没有难度，轻松有趣 <br data-v-890d2258>更多有趣关卡等你来加入，控制小球的运动 <br data-v-890d2258>开始之后难度会逐渐增加，挑战会更加精彩 <br data-v-890d2258>超级放松的休闲减压挑战，不会有什么难度 </p><a href=\"https://v.cdsjtech.com/d/wdppl.apk\" data-v-890d2258><img src=\"" + _imports_3 + "\" alt=\"\" data-v-890d2258></a></div></div>", 3);
import { reactive, onMounted } from 'vue';
import Headers from "@/components/header/index.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({});
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Headers, {
        class: "headers"
      }), _hoisted_2]);
    };
  }
});